import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { LoginDto } from "./dto/login.dto";
import { firstValueFrom } from "rxjs";
import { URLS } from "../constants/constants";
import { LoginResponseDto } from "./dto/login.response.dto";

@Injectable()
export class LoginService {

    private http = inject(HttpClient);
    login(loginDto:LoginDto): Promise<LoginResponseDto>{
       return  firstValueFrom(this.http.post<LoginResponseDto>(`${URLS.LOGIN_API}`,loginDto));  
    }

}